// extracted by mini-css-extract-plugin
module.exports = {"forgot-password-wrapper":"ForgotPassword_forgot-password-wrapper__Nw0_e","forgot-password":"ForgotPassword_forgot-password__j6G1H"};